import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { last } from 'lodash';
import { openMessagesSessionModal } from '../../data/fileImport/modalActions';

const SessionMessage = props => {
  const dataTreeMessages = props.messages;

  if (props.dataTree) {
    const lastMessage = last(dataTreeMessages);
    let messageParameters = {};

    if (lastMessage && lastMessage[`${lastMessage.type}_error_parameters`]) {
      messageParameters = lastMessage[`${lastMessage.type}_error_parameters`].reduce(
        (params, obj) => {
          params[obj.error_parameter.name] = obj.value;
          return params;
        },
        {}
      );
    }

    const nbMessages = dataTreeMessages.length;
    return (
      <div
        className="sessionMessages__container"
        onClick={event => props.dispatch(openMessagesSessionModal(props.dataTree.id))}
      >
        <p className="sessionMessages__text">
          {lastMessage ? props.t(lastMessage.error.error_key, messageParameters) : ''}
        </p>
        {nbMessages > 0 && <span className="sessionMessages__nb">{nbMessages}</span>}
      </div>
    );
  }

  return false;
};
SessionMessage.propTypes = {
  dataTree: PropTypes.object,
  messages: PropTypes.array
};

export default connect()(translate()(SessionMessage));



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/SessionMessage.js